'use client';

import { cn } from '@/lib/utils';

export default function Radio({
  name,
  value,
  checked,
  onChange,
  label,
  description,
  disabled = false,
  className,
  ...props
}) {
  const id = `radio-${name}-${value}`;

  return (
    <label
      htmlFor={id}
      className={cn(
        'flex items-start gap-3 cursor-pointer',
        disabled && 'cursor-not-allowed opacity-50',
        className
      )}
    >
      <div className="flex items-center h-5">
        <input
          type="radio"
          id={id}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={cn(
            'w-4 h-4 border-2 border-slate-300 text-blue-600',
            'focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
            'disabled:cursor-not-allowed disabled:opacity-50'
          )}
          {...props}
        />
      </div>
      {(label || description) && (
        <div className="flex flex-col">
          {label && (
            <span className={cn(
              'text-sm font-medium',
              disabled ? 'text-slate-400' : 'text-slate-700'
            )}>
              {label}
            </span>
          )}
          {description && (
            <span className="text-xs text-slate-500 mt-0.5">
              {description}
            </span>
          )}
        </div>
      )}
    </label>
  );
}

export function RadioGroup({
  name,
  value,
  onChange,
  options,
  direction = 'vertical',
  disabled = false,
  className,
}) {
  return (
    <div
      className={cn(
        'flex',
        direction === 'vertical' ? 'flex-col gap-3' : 'flex-row flex-wrap gap-4',
        className
      )}
      role="radiogroup"
    >
      {options.map((option) => (
        <Radio
          key={option.value}
          name={name}
          value={option.value}
          checked={value === option.value}
          onChange={() => onChange?.(option.value)}
          label={option.label}
          description={option.description}
          disabled={disabled || option.disabled}
        />
      ))}
    </div>
  );
}
